<!-- V3 is invisible and is there by default - if can't pass V3 FOR ANY REASON will show V2 -->
<div *ngIf="showRecaptchaV2 == true">
    <lib1-shared-captcha-v2 (recaptchaV2ResultEmitter)="recaptchaV2ResultEmitterSubscriber($event)"></lib1-shared-captcha-v2>
</div>